import {
  InventoryMeterReadingGroup,
  OutputTechnology,
  SerializedInventoryMeterReadingGroup,
} from '@enmon/commons/lib/tools';
import { Button, Card, Descriptions, Form, FormInstance, Input, Row } from 'antd';
import { FormItem } from 'components/Form/FormItem';
import { Select } from 'components/Select/Select';
import { VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GroupDetailCard as messages } from '../messages';
import { GroupDetailsForm } from '../types';
import { outputTechnologyTranslated } from '../../../components/Form/meter_details/messages';

interface GroupDetailCardProps {
  title: string;
  group?: SerializedInventoryMeterReadingGroup;
  groupForm: FormInstance<GroupDetailsForm>;
  onFinish: (values: GroupDetailsForm) => void;
  groupId?: number;
  isLoading?: boolean;
}

export const GroupDetailCard: VFC<GroupDetailCardProps> = ({
  title,
  group,
  groupForm,
  onFinish,
  groupId,
  isLoading,
}) => {
  const intl = useIntl();

  return (
    <Card title={title}>
      <Form key={group?.id} form={groupForm} initialValues={{ ...group }} layout="horizontal" onFinish={onFinish}>
        <Descriptions bordered column={1} layout="vertical" size="middle">
          {groupId && <Descriptions.Item label="Id">{groupId}</Descriptions.Item>}
          <Descriptions.Item
            label={
              <>
                <span style={{ color: 'red' }}>*</span> <FormattedMessage {...messages.name} />
              </>
            }
          >
            <FormItem
              noStyle
              required
              name={'name' satisfies keyof InventoryMeterReadingGroup}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage(messages.nameIsRequired),
                },
              ]}
            >
              <Input required placeholder={intl.formatMessage(messages.groupNameInput)} />
            </FormItem>
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.description} />}>
            <FormItem noStyle name={'description' satisfies keyof InventoryMeterReadingGroup}>
              <Input.TextArea placeholder={intl.formatMessage(messages.groupDescriptionInput)} rows={3} />
            </FormItem>
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.metersTechnology} />}>
            <FormItem noStyle name={'technology' satisfies keyof InventoryMeterReadingGroup}>
              <Select
                allowClear
                placeholder={intl.formatMessage(messages.selectTechnology)}
                size="large"
                style={{ width: '100%' }}
              >
                {Object.values(OutputTechnology).map(technology => (
                  <Select.Option key={technology} value={technology}>
                    {intl.formatMessage(outputTechnologyTranslated[technology])}
                  </Select.Option>
                ))}
              </Select>
            </FormItem>
          </Descriptions.Item>
        </Descriptions>
        <Row justify="end" style={{ marginTop: 24 }}>
          <Button htmlType="submit" loading={isLoading} type="primary">
            <FormattedMessage {...messages.saveChanges} />
          </Button>
        </Row>
      </Form>
    </Card>
  );
};
